export const CommentableType = Object.freeze({
  TrainingClass: 'TrainingClass',
  Recipe: 'Nutrition::Recipe',
});
